import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INotification, INotificationsState } from 'shared/types/features';

export const initialNotificationsState: INotificationsState = {
  list: [],
};

const notificationsSlice = createSlice({
  initialState: initialNotificationsState,
  name: 'notifications',
  reducers: {
    addNotification: (state, action: PayloadAction<INotification>) => {
      state.list.push(action.payload);
    },
    clearNotifications: state => {
      state.list = [];
    },
  },
});

export const {
  reducer: notificationsReducer,
  actions: { addNotification, clearNotifications },
} = notificationsSlice;
